let common = {
  // 1000: '漫微',1001: '聚合',1002: '随行付',1003: 'office web 365',1004: '通联支付',1005: '小服人力'
  codeVendor: {
    1002: '随行付',
    1005: '小服人力',
    1006: '美差',
    1007: '支付宝自营',
    1008: '支付宝人资',
    1010: '慧算账',
    1012: '企嗨',
    1013: '云账户',
    1015: '柒沃',
  },
  codeReceive: {
    1: '支付宝',
    2: '微信',
    3: '对公(招商银行)'
  },
  codeReceiveStatus: {
    10: '待收款',
    20: '收款成功',
    30: '收款失败',
    40: '交易关闭'
  },
  codeStatus: {
    0: '待支付',
    10: '支付中',
    20: '银行处理中',
    30: '支付成功',
    40: '支付失败',
    50: '已拒绝',
    60: '已退票',
    70: '提交失败',
  },
  statusList: [
    { label: '待支付', value: 0},
    { label: '支付中', value: 10},
    { label: '银行处理中', value: 20},
    { label: '支付成功', value: 30},
    { label: '支付失败', value: 40},
    { label: '已拒绝', value: 50},
    { label: '已退票', value: 60},
    { label: '提交失败', value: 70},
  ],
  copy (obj) {
    return JSON.parse(JSON.stringify(obj))
  }
}
export default common



// WEBPACK FOOTER //
// ./src/common/index.js